export default __webpack_public_path__ + "static/kinga_marszalkowska-95087d8a79c4196b0ddd3dc2f8845aaf.jpg";